define('charts/layers/profilefocus',["require", "exports", "../../baseline/colors", "../../util/convert"], function (require, exports, colors_1, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ProfileFocus = void 0;
    var ProfileFocus = /** @class */ (function () {
        function ProfileFocus(options) {
            this.labelWidth = 75;
            this.options = options;
        }
        ProfileFocus.prototype.init = function (chart) {
            this.chart = chart;
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "focus")
                .style("display", "none");
            this.circle = this.svgGroup.append("circle")
                .attr("r", 7)
                .style("stroke-width", 0)
                .style("fill-opacity", 0.4)
                .style("fill", "#000");
            this.svgGroup.append("circle")
                .attr("r", 2)
                .style("stroke-width", 0)
                .style("fill", "#000");
            this.label = this.svgGroup.append("g")
                .attr("class", "focus-label");
            this.label.append("rect")
                .attr("x", 5)
                .attr("y", 5)
                .attr("rx", 4)
                .attr("ry", 4)
                .attr("width", this.labelWidth)
                .attr("height", 53);
            this.text = this.label.append("text");
            this.text1 = this.text.append("tspan")
                .attr("x", 10)
                .attr("y", 5)
                .attr("dy", "1.1em");
            this.text2 = this.text.append("tspan")
                .attr("x", 10)
                .attr("dy", "1.1em");
            this.text3 = this.text.append("tspan")
                .attr("x", 10)
                .attr("dy", "1.1em");
        };
        ProfileFocus.prototype.update = function (chart) {
            // Nothing to update
        };
        ProfileFocus.prototype.drawFocus = function (point, track) {
            if (!this.chart)
                return;
            var x = point ? this.options.fx(point) : undefined;
            var y = point ? this.options.fy(point) : undefined;
            if (track && point && x !== undefined && y !== undefined) {
                var timeString = "";
                // For actual tracks:
                if (track.trackType === "track" || track.trackType === undefined) {
                    // Find time delta from start time
                    var delta = (point.millis - track.startTime()) / 1000;
                    timeString = "t: " + delta + " s";
                }
                // x,y label strings
                var xString = "x: " + Math.floor(x) + " " + convert_1.default.distance.label;
                var yString = "y: " + Math.floor(y) + " " + convert_1.default.distance.label;
                var sx = Math.round(this.chart.xAxis.scale(x)) + 0.5;
                var sy = Math.round(this.chart.yAxis[0].scale(y)) + 0.5;
                this.svgGroup
                    .attr("transform", "translate(" + sx + "," + sy + ")");
                // Text alignment
                var offsetX = 0;
                var offsetY = 0;
                if (this.chart.width() - this.labelWidth < sx) {
                    offsetX = -85;
                }
                if (this.chart.height() - 55 < sy) {
                    offsetY = -64;
                }
                this.label.attr("transform", "translate(" + offsetX + "," + offsetY + ")");
                this.text1.text(xString);
                this.text2.text(yString);
                this.text3.text(timeString);
                this.circle.style("fill", (0, colors_1.trackColor)(track));
                this.svgGroup.style("display", null);
            }
            else {
                this.svgGroup.style("display", "none");
            }
        };
        ProfileFocus.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return ProfileFocus;
    }());
    exports.ProfileFocus = ProfileFocus;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/profilefocus.js.map;
